module.exports = __webpack_public_path__ + "static/media/meet-piper-tabletPro-en.89d40ce2.svg";